<template>
  
  <div>
    <dx-popup
      :width="350"
      :height="300"
      :show-title="false"
      :drag-enabled="false"
      :close-on-outside-click="true"
      :visible.sync = "isShown"
      :on-hiding = "closeform"
    >

    <v-container  grid-list-xl pt-0>
			<app-card>

     <v-layout row wrap>
        <v-flex sm12>
        <h3>Notitie</h3>
        </v-flex>
        <v-flex sm12>
          <dx-text-area placeholder="Type a text here..." height="100"  :value.sync="this.noteText"></dx-text-area>
        </v-flex>
        <v-flex sm12>
        <dx-button text="Notitie opmaken" @click="btnNote" />
        </v-flex>
     </v-layout>
			</app-card>
    </v-container>

    </dx-popup>
  </div>

</template>

<style>
.dx-popup-content {
    padding: 0px;
}
.container {
  padding: 0px;
}
</style>

<script>

import { DxButton, DxPopup, DxPopover, DxTextArea } from 'devextreme-vue';

export default {
  components: {
    DxButton, DxPopup, DxPopover, DxTextArea
  },
   props: {
  },
  data: function() {
    return {
      showForm : false,
      noteText : '',
      position: {
        offset: '0, 2',
        at: 'bottom',
        my: 'top',
        collision: 'fit flip'
      }
    };
  },
 mounted() {

  },
  computed: {
     isShown () {
         return this.showForm;
     }
  },
  methods: {
      closeform () {
          console.log ("Closing form");
          this.showForm = false;
      },
      show (item) {
          console.log ("Show form");

         if (item != undefined)
         {
             this.noteText = item.appointmentData.itemobject.Message;
         }

          this.showForm = true;
      },
      btnAppoint () {
          console.log ("afspraak klik");
      },
      btnNote () {
          console.log ("notitie klik");
      }
  }
};
</script>